import { DotHeadless } from "@dotdev/dotheadless-app"

export const useCore = () => ({ ...DotHeadless })
